import script from "./CommonAPI.vue?vue&type=script&lang=js"
export * from "./CommonAPI.vue?vue&type=script&lang=js"

export default script